import { AfterViewInit, Component, EventEmitter, OnInit, Output, OnDestroy, OnChanges } from '@angular/core'
import { Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { arrayMoveMutable } from 'array-move'
import { ApiService } from '../api.service'

declare var $: any

@Component({
	selector: 'app-generate-course-form-wikilinks',
	templateUrl: './generate-course-form-wikilinks.component.html',
	styleUrls: ['./generate-course-form-wikilinks.component.scss']
})

export class GenerateCourseFormWikilinksComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	userID = 0
	
	courseFormID = 0
	courseFormName = ''
	courseFormHeadingWords = 0
	courseFormCategory = -1
	newCourseID = 0
	
	searchLimit = 10
	// searchLimit = 50
	// searchTerm = ''
	searchTerm = 'Inteligencia artificial'
	searchOrder = 'relevance'
	wikipediaSearchResults: any[] = []
	units: any[] = []

	searching = false
	searchSuccess = false
	searchError = false
	generateLoading = false
	generateSuccess = false
	generateError = false
	generateBtnDisabled = true

	wikiSub = new Subscription
	generateUnitLessonsWikilinksSub = new Subscription
	taskStatusCelerySub = new Subscription
	deleteCourseSub = new Subscription
	importSub = new Subscription

	jsTree: any = $.jstree!
	
	@Output() moveEvent = new EventEmitter<any>()
	
	constructor(private dataService: ApiService, private router: Router) {}

	ngOnInit(): void {
		// console.log('form wikilinks init')
	}
	
	ngAfterViewInit(): void {
		this.userID = this.dataService.getUserID()
		this.jstreeInit()
		this.emptyUnits()
		// this.jstreeUpdate()

		// console.log('form wikilinks after view init')
	}
	
	ngOnChanges(): void {
		// console.log('form wikilinks changes')
	}

	ngOnDestroy(): void {
		this.wikiSub?.unsubscribe()
		this.generateUnitLessonsWikilinksSub?.unsubscribe()
		this.taskStatusCelerySub?.unsubscribe()
		this.deleteCourseSub?.unsubscribe()
		this.importSub?.unsubscribe()

		// console.log('form wikilinks destroy')
	}

	move(event: MouseEvent) {
		this.moveEvent.next(event)
	}

	wikipediaSearch() {
		if (this.searchTerm === undefined || this.searchTerm === "") {
			alert("Por favor, introduzca un término de búsqueda.")
			return
		}

		this.searching = true
		this.generateBtnDisabled = true

		this.wikiSub = this.dataService.wikipediaSearch(this.searchTerm, this.searchLimit, this.searchOrder)
		.subscribe(
			data => {
				this.searching = false

				let results = data.query.search
				if (results.length > 0) {
					this.searchSuccess = true
					this.searchError = false
				} else {
					this.searchSuccess = false
					this.searchError = true
				}
				// console.log(results)

				this.wikipediaSearchResults = []
				// this.selectedResults = []
				results.forEach((result: any) => {
					let word = result.title
					let link = 'https://es.wikipedia.org/wiki/' + word.replaceAll(' ', '_')
					
					this.wikipediaSearchResults.push({
						'word': word,
						'link': link,
						'lastedit': result.timestamp,
						'wordcount': result.wordcount,
						'unit': -1,
						'populating': false,
						'populated': undefined,
					})
				})

				if (this.units.length > 0) this.generateBtnDisabled = false
				// console.log(this.wikipediaSearchResults)
				// console.log(this.units)
			},
			_error => {
				// console.log(error)
			}
		)
	}

	populateUnit(result: any) {
		// console.log(result)

		result.populating = true
		let link = result.link
		// console.log(link)
		let word = result.word
		// console.log(word)
		
		let unitPos = +result.unit
		if (unitPos == -1) {
			result.populating = false
			alert('Por favor, seleccione una unidad para poblar.')
			return
		}
		// console.log(unitPos)

		this.generateUnitLessonsWikilinksSub = this.dataService.generateUnitLessonsWikilinks(link)
		.subscribe(
			data => {
				// console.log(data)
				let task = data.id

				let interval = 500
				let idinterval = setInterval(() => {
					this.taskStatusCelerySub = this.dataService.taskStatusCelery('wikipedia', task)
						.subscribe(
							data => {
								// console.log(data)
								let status = data.status
								if (status !== "SUCCESS") return

								window.clearTimeout(idinterval)
								result.populating = false

								let lessons = data.result.course[0].lessons
								// console.log(lessons)

								lessons.forEach((lesson: any) => {
									// console.log(lesson)
									lesson.title = word + ': ' + lesson.title
									this.units[unitPos].lessons.push(lesson)
								})
								result.populated = true

								// this.units[unitPos].lessons = lessons
								// this.units[unitPos].title = prevTitle
								this.units[unitPos].text = this.units[unitPos].title
								this.jstreeUpdate()
								this.generateBtnDisabled = false
							},
							_error => {
								// console.log(error)
								window.clearTimeout(idinterval)
								result.populating = false
								result.populated = false
							},
						)
				}, interval)
			},
			_error => {
				// console.log(error)
				result.populating = false
				result.populated = false
			}
		)
	}

	emptyUnits() {
		this.units.splice(0, this.units.length)
		this.units.push({
			'title': 'Unidad de aprendizaje 1',
			'pos': 0,
			'lessons': [],
			'type': 'unit',
		})
		this.jstreeUpdate()
	}

	generateCourseWikilinks() {
		this.courseFormID = this.dataService.getCourseFormID()
		this.courseFormName = this.dataService.getCourseFormName()
		this.courseFormHeadingWords = this.dataService.getCourseFormHeadingWords()
		this.courseFormCategory = this.dataService.getCourseFormCategory()

		if (this.units.length === 0) {
			alert('Por favor, seleccione al menos un término.')
			return
		}
		
		this.generateBtnDisabled = true
		this.generateLoading = true
		this.generateSuccess = false
		this.generateError = false

		if (this.courseFormID > 0) {
			this.deleteCourseSub = this.dataService.deleteCourse(this.courseFormID)
			.subscribe(
				_data => {
					// console.log(data)
				},
				_error => {
					// console.log(error)
					this.generateLoading = false
					this.generateSuccess = false
					this.generateError = true
					this.generateBtnDisabled = false
				}
			)
		}

		setTimeout(() => {
			// console.log(this.units)
			this.importSub = this.dataService.importCourse(this.units, this.courseFormID, this.courseFormName, this.courseFormHeadingWords, this.courseFormCategory, 'wikilinks')
			.subscribe(
				id => {
					// console.log(data)
					this.generateLoading = false
					this.generateSuccess = true
					this.generateError = false
					
					this.dataService.clearCourseForm()
					this.newCourseID = id
					setTimeout(() => {
						this.router.navigate(['course', id])
					}, 2000)
				},
				_error => {
					// console.log(error)
					this.generateLoading = false
					this.generateSuccess = false
					this.generateError = true
					this.generateBtnDisabled = false
				}
			)
		}, 1000)
	}

	// JSTree
	jstreeInit() {
		$(() => {

			var jstree_elem = $("#wikilinks-jstree")
			var jstree_tree = jstree_elem.jstree(true)
			let icons_root = "assets/img/simpletree-icons/"

			this.jsTree.defaults.contextmenu!.items = (node: any) => {

				let unit_items = {
					newUnit: {
						label: "Insertar unidad",
						icon: icons_root + "folder_add.png",
						action: () => {
							// console.log(node)
							let new_pos = this.units.length + 1
							let node_id = 'unit_' + new_pos
							let new_node_data = {
								'id': node_id,
								'text': 'Unidad de aprendizaje ' + (new_pos),
								'type': 'unit',
							}
							jstree_tree.create_node("#", new_node_data, "last", (node: any) => {
								jstree_tree.edit("#" + node.id, undefined, (node: any, status: boolean, canceled: boolean) => {
									if (status && !canceled) {
										let title = node.text
										this.units.push({
											'id': node_id,
											'title': title,
											'text': title,
											'lessons': [],
											'type': 'unit',
											'pos': new_pos,
										})
										this.jstreeUpdate()
									}
								})
							})

						}
					},
					/*
					newLesson: {
						label: "Insertar lección",
						icon: icons_root + "folder_add.png",
						action: () => {
							// console.log(node)
							let unit_pos = +node.original.pos
							let lessons_num = this.units[unit_pos].lessons.length
							let node_id = 'unit_' + (unit_pos + 1) + '_lesson_' + (lessons_num + 1)
							let new_node_data = {
								'id': node_id,
								'text': 'Lección ',
								'type': 'lesson',
							}
							jstree_tree.create_node("#" + node.id, new_node_data, "last", (node: any) => {
								jstree_tree.edit("#" + node.id, undefined, (node, status, canceled) => {
									// console.log(node)
									if (status && !canceled) {
										this.units[unit_pos].lessons.push({
											'id': node_id,
											'title': node.text,
											'text': node.text,
											'type': 'lesson',
											'headings': [],
											'pos': lessons_num + 1,
											'unit_pos': unit_pos,
										})
										this.jstreeUpdate()
										console.log(this.units)
									}
								})
							})
						}
					},
					*/
					editUnit: {
						label: "Editar (F2)",
						icon: icons_root + "page_edit.png",
						action: () => {
							// console.log(node)
							jstree_tree.edit("#" + node.id, undefined, (node: any, _status: boolean, _canceled: boolean) => {
								// console.log(node)
								let unit_pos = +node.original.pos
								this.units[unit_pos].title = node.text
								this.units[unit_pos].text = node.text
								this.jstreeUpdate()
							})
						}
					},
					deleteUnit: {
						label: "Borrar (Supr)",
						icon: icons_root + "page_delete.png",
						action: () => {
							// console.log(node)
							let unit_pos = +node.original.pos
							// console.log(unit_pos)
							if (!confirm("¿Está seguro que quiere borrar esta unidad?")) return
							// jstree.jstree().delete_node("#" + node.id)
							this.units.splice(unit_pos, 1)
							this.jstreeUpdate()
						}
					}
				}

				let lesson_items = {
					editLesson: {
						label: "Editar (F2)",
						icon: icons_root + "page_edit.png",
						action: () => {
							// console.log(node)
							jstree_tree.edit("#" + node.id, undefined, (node: any, _status: any, _canceled: any) => {
								let lesson_pos = +node.original.pos
								let unit_pos = +node.original.unit_pos
								this.units[unit_pos].lessons[lesson_pos].title = node.text
								this.units[unit_pos].lessons[lesson_pos].text = node.text
								this.jstreeUpdate()
							})
						}
					},
					deleteLesson: {
						label: "Borrar (Supr)",
						icon: icons_root + "page_delete.png",
						action: () => {
							// console.log(node)
							if (!confirm("¿Está seguro que quiere borrar esta lección?")) return
							// jstree.jstree().delete_node("#" + node.id)
							let lesson_pos = +node.original.pos
							let unit_pos = +node.original.unit_pos
							this.units[unit_pos].lessons.splice(lesson_pos, 1)
							this.jstreeUpdate()
						}
					}
				}

				// console.log(node)
				let items = {}
				if (node.type === "unit")
					items = unit_items
				else if (node.type === "lesson")
					items = lesson_items

				return items
			}

			jstree_elem.on("changed.jstree", (_e: any, data: any) => {
				// console.log(e)
				// console.log(data)
				/*
				if (data.node !== undefined) {
					let node = data.node
					let type = node.type
					// console.log(type)
					// let id = +data.node.id
					// console.log(id)
				}
				*/
			})

			jstree_elem.on("keydown.jstree", (e: any) => {
				// console.log(e)
				// console.log(e.which)
				if (e.which >= 37 && e.which <= 40) e.preventDefault()
			})

			/*
			jstree_elem.on("select_node.jstree", (node: any, selected: any, event: any) => {
				console.log(node)
				console.log(selected)
				console.log(event)
			})
			*/

			/*
			jstree_elem.on("deselect_all.jstree", (e: any) => {
				// console.log(e)
			})
			*/

			/*
			jstree_elem.on("edit_node.jstree", (e: any, data: any) => {
				console.log(e)
				console.log(data)
			})
			*/

			jstree_elem.on("move_node.jstree", (_e: any, data: any) => {
				// console.log(data)
				let node = data.node
				let new_position = data.position
				let old_position = data.old_position
				// console.log("old_position: " + old_position)
				let type = node.type
				let new_parent = jstree_tree.get_node(data.parent)
				// console.log(new_parent)
				let new_parent_type = new_parent.type
				// let old_parent = jstree_tree.get_node(data.old_parent)
				// console.log(old_parent)
				if (type === 'unit') {
					if (new_parent_type === '#') {
						arrayMoveMutable(this.units, old_position, new_position)
					}
					else if (new_parent_type === 'unit') {
						let unit_pos = +new_parent.original.pos - 1
						// let unit_pos = +new_parent.id.replace('unit_', '') - 1
						if (unit_pos < 0) unit_pos = 0
						else if (unit_pos > this.units.length) unit_pos = this.units.length - 1
						// console.log("unit_pos: " + unit_pos)
						let lessons_num = this.units[unit_pos].lessons.length
						let lesson_id = 'unit_' + (old_position + 1) + '_lesson_' + (lessons_num + 1)
						this.units.splice(old_position, 1)
						this.units[unit_pos].lessons.push({
							'id': lesson_id,
							'title': node.text,
							'text': node.text,
							'type': 'lesson',
							'headings': [],
							'pos': lessons_num + 1,
							'unit_pos': unit_pos,
						})
					}
				} else if (type === 'lesson') {
					let unit_pos = +node.original.unit_pos
					arrayMoveMutable(this.units[unit_pos].lessons, old_position, new_position)
				}
				this.jstreeUpdate()
			})

			// jstree_elem.on("dnd_start.vakata", (data: any, elem: any, helper: any, e: any) => {
			jstree_elem.on("dnd_start.vakata", (_e: any, _data: any) => {
				// console.log(data)
				// console.log('start')
				// this.jstreeUpdate()
			})

			jstree_elem.on("dnd_move.vakata", (_data: any, _elem: any, _helper: any, _e: any) => {
				// console.log(data)
				// console.log('moving')
				// this.jstreeUpdate()
			})

			// jstree_elem.on("dnd_stop.vakata", (data: any, elem: any, helper: any, e: any) => {
			jstree_elem.on("dnd_stop.vakata", (_e: any, _data: any) => {
				// console.log(data)
				// console.log('stop')
				// this.jstreeUpdate()
			})

			jstree_elem.on("before_open.jstree", (_e: any, data: any) => {
				document.querySelector('#' + data.node.id + '_anchor > svg')?.setAttribute('data-icon', 'folder-open')
			})

			jstree_elem.on("after_close.jstree", (_e: any, data: any) => {
				document.querySelector('#' + data.node.id + '_anchor > svg')?.setAttribute('data-icon', 'folder')
			})

			jstree_elem.jstree({
				"core": {
					"check_callback": true,
					"multiple" : false,
					"themes": {
						"name": "default",
					},
					"data": this.units,
					/* 
					(operation, node, node_parent, node_position, more) => {
						// operation can be "create_node", "rename_node", "delete_node", "move_node", "copy_node" or "edit"
						// in case of "rename_node" node_position is filled with the new node name
						return operation === "rename_node" ? true : false
					}, 
					*/
					"keyboard": {
						'up': (e: any) => {
							// console.log(e)
							// console.log(e.originalEvent)
							let shift = e.originalEvent.shiftKey
							// console.log(shift)
							let node = jstree_tree.get_selected()[0]
							// console.log(node)
							let prev_node = jstree_tree.get_prev_dom(node)[0].id
							// console.log(prev_node)
							if (!shift) jstree_tree.deselect_all(true)
							jstree_tree.select_node(prev_node, false, false, e)
						},
						'down': (e: any) => {
							// console.log(e)
							// console.log(e.originalEvent)
							let shift = e.originalEvent.shiftKey
							// console.log(shift)
							let node = jstree_tree.get_selected()[0]
							// console.log(node)
							let next_node = jstree_tree.get_next_dom(node)[0].id
							// console.log(next_node)
							if (!shift) jstree_tree.deselect_all(true)
							jstree_tree.select_node(next_node, false, false, e)
						},
						/*
						'left': () => {
							alert("ArrowLeft")
						},
						*/
						/*
						'right': () => {
							alert("ArrowRight")
						},
						*/
						'delete': () => {
							// alert("Borrar")
							let nodes = jstree_tree.get_selected(true).reverse()
							let confirm_msg = ""
							if (nodes.length === 1) confirm_msg = "¿Está seguro que quiere borrar este elemento?"
							else if (nodes.length > 1) confirm_msg = "¿Está seguro que quiere borrar estos elementos?"
							if (!confirm(confirm_msg)) return
							nodes.forEach((node: any) => {
								// console.log(node)
								let type = node.type
								if (type === 'unit') {
									let id = +node.id.replace('unit_', '') - 1
									// console.log(id)
									this.units.splice(id, 1)
								}
							})
							this.jstreeUpdate()
						},
					}
				},
				"contextmenu": {
					"show_at_node": false
				},
				"dnd": {
					"copy": false,
					"is_draggable": true,
					"check_while_dragging": true,
				},
				"types": {
					"#": {
						"max_depth": 2,
						"valid_children": ["unit"],
					},
					"unit": {
						"icon": "fas fa-folder me-2",
						"max_depth": 1,
						"valid_children": ["lesson"],
					},
					"lesson": {
						"icon": "fas fa-folder me-2",
					},
				},
				"plugins": ["changed", "contextmenu", "dnd", "types", "wholerow"]
			})

			jstree_tree = jstree_elem.jstree(true)
		})
	}

	jstreeUpdate() {
		$(() => {
			let jstree: any = $("#wikilinks-jstree").jstree()

			let units_num = this.units.length
			if (units_num > 0) {
				for (let u = 0; u < units_num; u++) {
					let unit = this.units[u]
					unit.type = 'unit'
					unit.text = unit.title
					unit.pos = u
					unit.id = 'unit_' + (u + 1)
					unit.children = unit.lessons
	
					let lessons_num = unit.lessons.length
					for (let l = 0; l <= lessons_num; l++) {
						let lesson = unit.lessons[l]
						if (lesson === undefined) continue
						lesson.type = 'lesson'
						lesson.text = lesson.title
						lesson.pos = l
						lesson.unit_pos = u
						lesson.id = unit.id + '_lesson_' + (l + 1)
					}
				}
	
				jstree.settings!.core.data = this.units
				jstree.deselect_all()
				jstree.refresh(true)
			}
		})
		// console.log(this.units)
	}
}